import { render, staticRenderFns } from "./alipayCom.vue?vue&type=template&id=30d8c7e1&"
import script from "./alipayCom.vue?vue&type=script&lang=js&"
export * from "./alipayCom.vue?vue&type=script&lang=js&"
import style0 from "./alipayCom.vue?vue&type=style&index=0&id=30d8c7e1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports